module.exports = __webpack_public_path__ + "cb7c8a3aef0e6877a51205fb5f5ed676.svg";